<script>
import { num1K1MParts, monthRefs } from '../common.js';

export let bgCssClass = 'bg-primary'
export let iconClass = 'fas fa-bicycle';
export let title = '-';
export let data = {};
export let units = '';
export let decimalPlaces = 0;
export let totalProp = 'totaltrips';

// setup data entries
let items = Object.keys(data).map(x => {
  let timeMin2019 = (units.indexOf("min") > -1) ? data[x][totalProp + '2019']/60 : data[x][totalProp + '2019'];
  let timeMin2020 = (units.indexOf("min") > -1) ? data[x][totalProp + '2020']/60 : data[x][totalProp + '2020'];
  let percentDiff = (((data[x][totalProp + '2019'] - data[x][totalProp + '2020'])/data[x][totalProp + '2019'])*100).toFixed(0)
  let change = (percentDiff < 0) ? 'up' : 'down'
  return {
    total2019: num1K1MParts(timeMin2019, decimalPlaces, 2),
    total2020: num1K1MParts(timeMin2020, decimalPlaces, 2),
    percentDiff: (percentDiff < 0) ? percentDiff * -1 : percentDiff,
    change,
    month: monthRefs.find(m => Number(m.no) === Number(x))
  }
  // num1K1MParts(figure2019, decimalPlaces)
})

let figureTarget2019;
let figureTarget2020;

</script>

<section class="{`${bgCssClass} sectionx hero is-fullheight`}">
  <div class="hero-body">
    <div class="container">
        <div class="ioreveal animate__animated" data-anicss="animate__fadeInDown">
          <h2><i class="{iconClass}"></i> {title}</h2>
		      <slot name="description"></slot>
        </div>

      <div class="flex-parent" style="margin-top: 20px">
        <div class="flex-child flex-child-month">
          <span class="month-prefix"></span>
        </div>
        <div class="flex-child">
          <div class="ioreveal animate__animated animate__delay-2s" style="animation-delay: 0.2s;" data-anicss="animate__fadeInUp">
            <p class="text-2019">2019</p>
          </div>
        </div>
        <div class="flex-child">
          <div class="ioreveal animate__animated animate__delay-2s" style="animation-delay: 0.2s;" data-anicss="animate__fadeInUp">
            <p class="text-2020">2020</p>
          </div>
        </div>
      </div>

    	{#each items as entry }
      <div class="flex-parent flex-parent-row">
        <div class="flex-child flex-child-month">
          <span
            class="month-prefix ioreveal animate__animated animate__delay-2s"
            style="animation-delay: 0.8s;"
            data-anicss="animate__fadeInLeft">{entry.month.name}</span>
        </div>
        <div class="flex-child">
          <div
            class="ioreveal animate__animated animate__delay-2s"
            style="animation-delay: 0.2s;"
            data-anicss="animate__fadeInUp">
            <h2 class="has-text-primary text-2019">
              <span
                data-countup="{entry.total2019.num}"
                data-countup-decplaces="{entry.total2019.suffix === 'M' ? 2 : decimalPlaces}"
                bind:this="{figureTarget2019}">0</span><span>{entry.total2019.suffix || ''}</span>
              <span class="units">{units}</span>
            </h2>
          </div>
        </div>
        <div class="flex-child">
          <div
            class="ioreveal animate__animated animate__delay-2s"
            style="animation-delay: 0.5s;"
            data-anicss="animate__fadeInUp">
            <h2 class="has-text-primary text-2020">
              <span
                data-countup="{entry.total2020.num}"
                data-countup-decplaces="{entry.total2020.suffix === 'M' ? 2 : decimalPlaces}"
                bind:this="{figureTarget2020}">0</span><span>{entry.total2020.suffix || ''}</span>
              <span class="units">{units}</span>
              <div class="percent-change ioreveal animate__animated animate__delay-3s" data-anicss="animate__fadeIn">
              {entry.percentDiff}%
              {#if entry.change === 'down'}
            		<i class="fas fa-arrow-down"></i>
              {:else}
                <i class="fas fa-arrow-up"></i>
              {/if}
              </div>
            </h2>
          </div>
        </div>
      </div>
	    {/each}

      {#if units.indexOf("min") <= -1}
      <div class="note">
        <p>
        <strong>M</strong> - million
        </p>
        <p>
        <strong>K</strong> - thousand
        </p>
      </div>
      {/if}

    </div>
  </div>
</section>

<style>
.flex-parent {
  /* margin-top: 10px; */
  margin-top: 0;
}
.flex-parent:nth-child(odd) {
  background-color: rgba(0,0,0,.1)
}
.flex-parent:nth-child(even) {
  /* background-color: rgba(225,255,255,.1) */
}
.month-prefix {
  font-size:1.2em;
  text-transform: uppercase;
}

.flex-child-month {
  text-align: left;
  margin-top: 20px;
  padding-left: 20px;
  flex-basis: 130px;
  /* border: solid 1px #fff; */
  flex-grow: 0;
}
.percent-change {
  display: inline-block;
  font-size: 26px;
  color: #333;
  margin-left: 10px;
}
.note {
  margin-top: 15px;
}
.note p {
  opacity: .8;
  font-size: 16px;
}
.fa-arrow-down {
  color: #ee2211;
}
.fa-arrow-up {
  color: green;
}
.units {
  font-size: .7em;
}
@media (max-width: 640px) {
  .flex-child-month {
    margin-top: 5px;
    padding-left: 10px;
    flex-basis: 80px;
  }
  .month-prefix {
    font-size: 1em;
  }
  h2 {
    font-size:1.4rem;
  }
  .percent-change {
    font-size: 18px;
    margin-left: 2px;
  }
}
</style>